/*
 * @Author: kangzhuang 742291831@qq.com
 * @Date: 2025-04-16 09:38:01
 * @LastEditors: kangzhuang 742291831@qq.com
 * @LastEditTime: 2025-04-16 09:38:15
 * @FilePath: \qrcode-web\src\utils\storage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const KEY = "token-look-exhinition-hall";

export const getToken = () => {
	return localStorage.getItem(KEY);
};

export const setToken = newToken => {
	return localStorage.setItem(KEY, newToken);
};

export const removeToken = () => {
	return localStorage.removeItem(KEY);
};
